import { connect } from 'react-redux';
import {
  fetchTranslatedText,
} from './translation-modal-actions';
import TranslatedSection from '../components/translated-section';

const mapStateToProps = state => ({
  translatorLanguages: state.translator.translatorLanguages,
  isLoading: state.translator.isLoading,
  locale: state.languageProvider.locale,
  translatedText: state.translator.translatedText,
  tags: state.ticketForm.tags,
});

const mapDispatchToProps = {
  fetchTranslatedText,
};

export default connect(mapStateToProps, mapDispatchToProps)(TranslatedSection);
